/* eslint-disable max-len */
import React, { useRef } from 'react'; // { useEffect, useState }
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import EpButton from '../EpButton';
import EpModal, { handleToggleModal } from '../EpModal';
import EpFormSelect from '../EpFormSelect';
import { storeUserLanguage } from '../../redux/actions/globalizationAction';
import useTranslation from '../../hooks/useTranslation';

export default function EpLanguageModal({ getTranslationsFunc }) {
  // Tags do Globalization
  const RequiredField = useTranslation('* Required Fied');
  const English = useTranslation('English');
  const Portuguese = useTranslation('Portuguese');
  const Select = useTranslation('Select');
  const SelectALanguage = useTranslation('Select a language');
  const Cancel = useTranslation('Cancel');
  const Apply = useTranslation('Apply');
  const Language = useTranslation('Language');

  const dispatch = useDispatch();
  const translationsCache = useSelector(state => state.globalization.translationsCache);
  const lastCacheTime = useSelector(state => state.globalization.lastCacheTime);
  // const currentUserLanguage = useSelector(state => state.globalization.language);

  // Configurações do Formik e Yup
  const formRef = useRef();

  const filterSchema = Yup.object().shape({
    language: Yup.string().required(RequiredField).nullable(),
  });

  // Ações dos botões do modal
  const handleChangeLanguage = (e) => {
    const selectedLanguage = formRef.current.values.language;

    // TODO: Colocar loading

    if (formRef.current) {
      formRef.current.handleSubmit();
    }

    // Caso seja validado o form
    if (formRef.current.isValid === true && selectedLanguage != null) {
      e.preventDefault();

      axios.defaults.headers.common['Accept-Language'] = selectedLanguage || 'en-US';

      // Faz requisição para trazer dados do idioma selecionado
      getTranslationsFunc(selectedLanguage, translationsCache, lastCacheTime);

      // Salva e persiste idioma selecionado para cada vez que o usuário logar ter um default
      localStorage.setItem('userLanguage', selectedLanguage);
      dispatch(storeUserLanguage(selectedLanguage));

      // TODO: Remover loading
      // TODO: Limpar campo de seleção de idioma

      handleToggleModal('modal--language');
    }
  };

  // const [languageInputEl, setLanguageInputEl] = useState(null);
  // const [languageInputValue, setLanguageInputValue] = useState(null);

  // useEffect(() => {
  //   setLanguageInputEl(document.getElementById('language-select').querySelectorAll('input'));
  // }, []);

  // const handleLanguageInputChange = () => {
  //   if (languageInputEl !== null && languageInputEl !== undefined) {
  //     setLanguageInputValue(languageInputEl[0].value);
  //   }
  // };

  const languageOptions = [
    {
      value: 'en-US', label: English,
    },
    {
      value: 'pt-BR', label: Portuguese,
    },
  ];

  const bodyContent = (
    <Formik
      innerRef={formRef}
      initialValues={{ language: null }}
      validationSchema={filterSchema}
    >
      {formikProps => (
        <form className="form-filters">
          <div className="row">
            <div className="mb-3">
              <EpFormSelect
                classError={formikProps.errors.language ? 'is-invalid' : ''}
                optionsSelect={languageOptions}
                inputId="language-select"
                placeholderText={Select}
                inputName="language"
                value={formikProps.values.language}
                // onFocus={document.addEventListener('keyup', handleLanguageInputChange)}
                onChange={(val) => { formikProps.setFieldValue('language', val.value); }}
                onBlur={formikProps.handleBlur}
                labelText={SelectALanguage}
              />

              {/* TODO: Deixar essa versão de select comentada e habilitar somente quando for para trazer todos os idiomas cadastrados no globalization */}
              {/* <EpSelectPagination
                classError={formikProps.errors.language ? 'is-invalid' : ''}
                onBlur={formikProps.handleBlur}
                value={formikProps.values.language}
                // defaultValue={{ value: currentUserLanguage, label: Select }}
                onFocus={document.addEventListener('keyup', handleLanguageInputChange)}
                onChange={(val) => { formikProps.setFieldValue('language', val.value); }}
                inputId="language-select"
                placeholderText={Select}
                labelText={SelectALanguage}
                isSearchable
                baseUrlAPI={GLOBALIZATION_BASE_API_URL}
                endpointAPI={GLOBALIZATION_GET_CULTURES_ENDPOINT}
                params={{
                  Order: 2,
                  Page: 0,
                  Name: languageInputValue,
                }}
                optionValueProp="code"
                optionLabelProp="name"
                formatOptionLabel={false}
              /> */}
              {formikProps.errors.language && <div className="error-message">{formikProps.errors.language}</div>}
            </div>
          </div>
        </form>
      )}
    </Formik>
  );

  const footerContent = (
    <>
      <EpButton
        actionType="button"
        labelText={Cancel}
        linkFunc={() => handleToggleModal('modal--language')}
        buttonType="secondary-outline"
        buttonIcon={<FaTimes className="btn__icon" />}
        customClass="btn__footer"
        disabled={false}
      />

      <EpButton
        actionType="submit"
        labelText={Apply}
        linkFunc={e => handleChangeLanguage(e)}
        buttonType="primary"
        buttonIcon={<FaCheck className="btn__icon" />}
        customClass="btn__footer"
        disabled={false}
      />
    </>
  );

  return (
    <EpModal
      modalId="modal--language"
      headerTitle={Language}
      bodyContent={bodyContent}
      footerContent={footerContent}
      size="md"
    />
  );
}

EpLanguageModal.propTypes = {
  getTranslationsFunc: PropTypes.func.isRequired,
};
